import React from 'react'

function Heading({title}) {
  return (
      <div className="headingall_page">
        <div className="headingtitle">
          <h4 class="page-title">{title}</h4>
        </div>
      </div>
  )
}

export default Heading
